import * as _ from 'lodash';
import { Injectable, Signal, WritableSignal, computed, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FundraiserListService {

  public list: WritableSignal<any[]> = signal([]);

  public campaign: Signal<any> = computed(() => {
    const list = this.list();
    const fundraiser = list[0] || {
      campaignData: null
    };
    return fundraiser.campaignData;
  });

  public transactions: Signal<any[]> = computed(() => {
    const list = this.list();
    const result = [];
    
    list.forEach((fundraiser) => {
      const { transactions } = fundraiser;
      transactions.forEach((transaction) => {
        result.push(transaction);
      })
    });

    return result;
  });

  public pledges: Signal<any[]> = computed(() => {
    const list = this.list();
    const result = [];

    list.forEach((fundraiser) => {
      const pledges = fundraiser.pledges || [];
      pledges.forEach((pledge) => {
        result.push(pledge);
      })
    });

    return result;
  });

  public donors: Signal<any[]> = computed(() => {
    const transactions = this.transactions();
    const pledges = this.pledges();
    const campaign = this.campaign();
    const donorsMap = new Map();

    transactions.forEach((transaction) => {
      const donorId = transaction.payer.id;
      const existingDonor = donorsMap.get(donorId);
      
      if (existingDonor) {
        donorsMap.set(donorId, {
          ...existingDonor,
          campaignAdditionalInfo: transaction.campaignAdditionalInfo || existingDonor.campaignAdditionalInfo,
          additionalInfoSelected: transaction.additionalInfoSelected || existingDonor.additionalInfoSelected,
          transactionCount: this.getDonationCount(donorId)
        });
      } else {
        donorsMap.set(donorId, {
          ...transaction.payer,
          campaignAdditionalInfo: transaction.campaignAdditionalInfo || null,
          additionalInfoSelected: transaction.additionalInfoSelected || null,
          transactionCount: this.getDonationCount(donorId),
          pledgePerEvent: campaign.campaignTypeData?.pledgePerEvent || false,
          pledgeCount: this.getPledgesCount(donorId)
        });
      }
    });

    pledges.forEach((pledge) => {
      const donorId = pledge.donorInfo.id;
      const existingDonor = donorsMap.get(donorId);

      if (existingDonor) {
        donorsMap.set(donorId, {
          ...existingDonor,
          pledgePerEvent: campaign.campaignTypeData?.pledgePerEvent || false,
          pledgeCount: this.getPledgesCount(donorId)
        });
      } else {
        donorsMap.set(donorId, {
          ...pledge.donorInfo,
          campaignAdditionalInfo: '',
          additionalInfoSelected: [],
          transactionCount: this.getDonationCount(donorId),
          pledgePerEvent: campaign.campaignTypeData?.pledgePerEvent || false,
          pledgeCount: this.getPledgesCount(donorId)
        });
      }
    });

    return Array.from(donorsMap.values());
  });

  public uniqueDonors: Signal<any[]> = computed(() => {
    const donors = this.donors();
    return _.uniqBy(donors, (donor) => {
      return donor.id;
    });
  });

  constructor() { }

  getFundraiserListByUserId = function(id) {
    const list = this.list();
    return _.filter(list, ({ userId }) => {
      return userId == id;
    })
  }

  getFundraiserListByDonorId = function(id) {
    const list = this.list();
    const campaign = this.campaign();
    const pledgePerEvent = campaign.campaignTypeData?.pledgePerEvent || false;

    return _.filter(list, (fundraiser) => {
      const hasTransaction = _.find(fundraiser.transactions || [], ({ payer }) => payer.id == id);
      const hasPledge = pledgePerEvent && _.find(fundraiser.pledges || [], ({ donorInfo }) => donorInfo.id == id);
      
      return hasTransaction || hasPledge;
    });
  }

  getDonationCount(id) {
    const transactions = this.transactions();
    const { length } = transactions.filter(({ payer }) => {
      return payer.id == id;
    });
    return length;
  }

  getPledgesCount(id) {
    const pledges = this.pledges();
    const { length } = pledges.filter(({ donorInfo }) => {
      return donorInfo.id == id;
    });
    return length;
  }
}
